import State from '../core/State';
import User from '../entity/User';
import initialState from '../initialState';

export const startAuthenticationWithPreviousSession = () => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    // prepareing: true,
    fetching: state.authentication.fetching + 1,
  },
});

export const finishAuthenticationWithPreviousSession = () => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    // prepareing: false,
    fetching: state.authentication.fetching - 1,
  },
});

export const setSignedInUser = (user: User) => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    signedInUser: user,
  },
});

export const disposeRedirectURL = () => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    done: initialState.authentication.done,
  },
});

export const disposeUser = () => (state: State): State => ({
  ...state,
  authentication: {
    ...state.authentication,
    signedInUser: initialState.authentication.signedInUser,
  },
});
